// src/pages/admin/Warnings.jsx
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CrudPage from '../../components/admin/CrudPage';
import { dosageAPI, medicineAPI } from '../../services/api';

const SEVERITY_BADGE = {
  low:      'badge-info',
  medium:   'badge-warning',
  high:     'badge-danger',
  critical: 'badge-critical',
};

const Form = ({ form, onChange, medicines }) => (
  <>
    <div className="form-group">
      <label className="form-label required">Medicine</label>
      <select className="form-select" name="medicine_id" value={form.medicine_id || ''} onChange={onChange} required>
        <option value="">— Select Medicine —</option>
        {medicines.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
      </select>
    </div>
    <div className="form-group">
      <label className="form-label required">Warning Title</label>
      <input className="form-input" name="title" value={form.title || ''} onChange={onChange} placeholder="e.g. Penicillin Allergy Alert" required />
    </div>
    <div className="form-group">
      <label className="form-label">Severity</label>
      <select className="form-select" name="severity" value={form.severity || 'medium'} onChange={onChange}>
        <option value="low">Low</option>
        <option value="medium">Medium</option>
        <option value="high">High</option>
        <option value="critical">Critical</option>
      </select>
    </div>
    <div className="form-group">
      <label className="form-label">Description</label>
      <textarea className="form-textarea" name="description" value={form.description || ''} onChange={onChange} placeholder="Describe the warning in clinical detail…" rows={4} />
    </div>
  </>
);

export default function Warnings() {
  const [medicines, setMedicines] = useState([]);
  const [filterMedicine, setFilterMedicine] = useState('');

  useEffect(() => { medicineAPI.getAll().then(r => setMedicines(r.data.data)); }, []);

  return (
    <AdminLayout title="Warnings">
      <CrudPage
        title="Warnings"
        subtitle="Manage safety warnings attached to medicines"
        searchKey="title"
        columns={[
          { key: 'medicine_name', label: 'Medicine' },
          { key: 'title',         label: 'Warning Title', render: r => <strong>{r.title}</strong> },
          { key: 'severity',      label: 'Severity', render: r => (
            <span className={`badge ${SEVERITY_BADGE[r.severity] || 'badge-gray'}`} style={{ textTransform: 'capitalize' }}>
              {r.severity}
            </span>
          )},
          { key: 'description', label: 'Description', render: r => (
            <span className="truncate" style={{ maxWidth: 300, display: 'block' }}>{r.description}</span>
          )},
        ]}
        fetchFn={dosageAPI.getWarnings}
        createFn={dosageAPI.createWarning}
        updateFn={dosageAPI.updateWarning}
        deleteFn={dosageAPI.deleteWarning}
        FormComponent={Form}
        formDefault={{ medicine_id: '', title: '', severity: 'medium', description: '' }}
        extraProps={{ medicines }}
        renderFilters={() => (
          <select className="form-select" style={{ maxWidth: 200, margin: 0 }}
            value={filterMedicine} onChange={e => setFilterMedicine(e.target.value)}>
            <option value="">All Medicines</option>
            {medicines.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
        )}
        customFilter={row => filterMedicine ? String(row.medicine_id) === filterMedicine : true}
      />
    </AdminLayout>
  );
}
